import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CoBorrowerState {
  borrowerId: string | null;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  email: string;
  phone: string;
  personalIdNumber: string;
  isLocked: boolean;
  eligible: boolean;
  fullConsentAgreed: boolean;
  consentAgreed: boolean;
  annualIncome: number;
}

const initialState: CoBorrowerState = {
  borrowerId: null,
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  email: '',
  phone: '',
  personalIdNumber: '',
  isLocked: false,
  eligible: false,
  fullConsentAgreed: false,
  consentAgreed: false,
  annualIncome: 0,
};

const coBorrower = createSlice({
  name: 'coBorrower',
  initialState: initialState,
  reducers: {
    setCoBorrower: (state: CoBorrowerState, { payload }: PayloadAction<Partial<CoBorrowerState>>) => {
      Object.assign(state, payload);
    },
    clearCoBorrower: () => initialState,
  },
});

export const { setCoBorrower, clearCoBorrower } = coBorrower.actions;

export default coBorrower.reducer;
